import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/theme.css';
import './styles/globals.css';
import './index.css';
import { isDemoMode, ensureDemoSession } from './utils/demoMode';
import { getMockResponse } from './utils/mockApi';
import App from './App';

/* Apply theme to html before first paint so global bg matches dashboard everywhere */
(function setInitialTheme() {
  try {
    const v = localStorage.getItem('isNightMode');
    const isNight = v !== null ? JSON.parse(v) : true;
    document.documentElement.className = isNight ? 'night' : 'day';
    document.documentElement.setAttribute('data-theme', isNight ? 'dark' : 'light');
  } catch {
    document.documentElement.className = 'night';
    document.documentElement.setAttribute('data-theme', 'dark');
  }
})();

// Demo mode: intercept API calls and return mock data so the app works without backend
if (isDemoMode()) {
  ensureDemoSession();
  const realFetch = window.fetch;
  window.fetch = function demoFetch(url, options = {}) {
    const urlStr = typeof url === 'string' ? url : (url instanceof Request ? url.url : (url as URL).href);
    if (urlStr && urlStr.includes('caaliodatabase.xyz')) {
      let body = {};
      try {
        if (options.body && typeof options.body === 'string') {
          body = JSON.parse(options.body);
        }
      } catch (_) {}
      const mock = getMockResponse(urlStr, body);
      if (mock) {
        return Promise.resolve(mock);
      }
    }
    return realFetch.call(this, url, options);
  };
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  // <React.StrictMode>
    <App />
  // </React.StrictMode>
);
